/**
 * Helper to extract errors from the form.  This looks for errors on specific
 * fields from the wedding date field.  If any error exists for the wedding date
 * field, either on the individual components or the combined date validation
 * that error is returned a string
 */
import _get from 'lodash/get';
import { useFormState } from 'react-final-form';

import {
  RankedDateField,
  WeddingDateFormFields,
} from '~/components/common/form/WeddingDateField/types';

export const useErrorSpy = (
  name: string,
  field: undefined | RankedDateField
): string | undefined => {
  const errorField = field ? `${field}.${name}` : name;

  const { errors } = useFormState<WeddingDateFormFields>();
  return _get(errors, errorField);
};
